import _ from "lodash";
import React, { useState } from "react";
import classes from "./TagPost.scss";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";

import { updatePost } from "Post/modules/PostModule";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import PostList from "./PostList/PostList";

function TagPost(props) {
  const {
    t,
    curriculumProgramType,
    feedList,
    updatePost,
    goToStep,
    userType,
  } = props;
  const [showAlert, setAlert] = useState(true);
  const onPostClicked = post => {
    const resourceId = _.get(post, "node.resourceItem.id");
    const unitPlanId = _.get(post, "node.unitPlan.id");
    const postTaggedElements = {};
    const postTaggedPYPChildren = [];
    _.forEach(_.get(post, "node.elementPYP", []), element => {
      const cloneElement = _.cloneDeep(element);
      if (!_.isEmpty(cloneElement?.id)) {
        postTaggedElements[cloneElement?.id] = {
          fieldUID: cloneElement?.fieldUID || cloneElement?.id,
          id: cloneElement?.id || cloneElement?.fieldUID,
          value: cloneElement?.value,
          parentType: cloneElement?.parentType,
        };
        postTaggedPYPChildren.push(cloneElement?.fieldUID);
      }
    });

    updatePost({
      elementPYP: _.get(post, "node.elementPYP", null),
      unitPlan: _.get(post, "node.unitPlan", null),
      resourceId: _.get(post, "node.resourceId", null),
      resourceType: _.get(post, "node.resourceType", null),
      postTaggedElements: postTaggedPYPChildren,
      selectFromPost: true,
      selectFromAllPYP: _.isNil(unitPlanId) && _.isNil(resourceId),
      resourceItem: _.get(post, "node.resourceItem", null),
      showTagLearningGoalsModal: false,
    });

    goToStep && goToStep("TAG_FROM_ALL_LEARNING_GOALS");
  };
  return (
    <div className={classes.container}>
      <div className={classes.modalHeaderTitle}>
        {t("journal:select_goals_from_recent_posts")}
      </div>
      <PostList
        onItemClicked={onPostClicked}
        feedList={feedList}
        t={t}
        showLoaderBar={false}
        curriculumProgramType={curriculumProgramType}
        showAlert={showAlert}
        isUserTypeStudent={userType == "student"}
      />
    </div>
  );
}

const mapActionCreators = {
  updatePost,
};
const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const courseIdFromParent = _.get(
    ownProps,
    "screenPanelProps.postDetails.courseId"
  );
  const courseId = courseIdFromParent
    ? courseIdFromParent
    : state.teacher.selected_class.selected_course;
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const userId = _.get(userInfo, "id");
  const userType = userInfo.user_type;
  const organizationId = _.get(userInfo, "org_id");
  const userEntityType = _.get(userInfo, "userEntityType");

  return {
    mode: state.post.postCreationMode,
    courseId,
    curriculumProgramType,
    userId: userInfo.id,
    userType,
    t: ownProps.t,
    feedList: _.get(ownProps, "postsWithGoals.edges", []),
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["common", "journal"] })
)(TagPost);
